import { useCallback, useEffect, useState } from 'react';
import { store } from 'redux/store';

import { Document } from 'types';
import { getInvestorDocuments } from '../api/getInvestorDocuments';

type Props = {
  investorId: string;
};

export const useGetInvestorDocuments = ({ investorId }: Props) => {
  const [documents, setDocuments] = useState<Document[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isError, setIsError] = useState<boolean>(false);

  const fetchDocuments = useCallback(async () => {
    setIsLoading(true);

    try {
      if (investorId) {
        const documents = await store.dispatch(
          getInvestorDocuments(investorId)
        );
        setDocuments(documents);
      } else {
        setDocuments([]);
      }
    } catch (error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  }, [investorId]);

  useEffect(() => {
    fetchDocuments();
  }, [fetchDocuments]);

  return { data: { documents }, isLoading, isError };
};
